/* eslint-disable filenames/match-regex */

import AppService from '@/services/App';

const inFlight = {};

const cacheKey = adAccountId => String(adAccountId);

const state = {
  cache: {},
  loading: {},
};

const getters = {
  subfields: state => (field, adAccountId) => state.cache[cacheKey(adAccountId)]?.[field] ?? null,
  allSubfields: state => adAccountId => state.cache[cacheKey(adAccountId)] ?? null,
  isLoading: state => adAccountId => state.loading[cacheKey(adAccountId)] === true,
};

const actions = {
  fetch({ state, commit }, { adAccountId }) {
    const key = cacheKey(adAccountId);

    // Explicit key check (not truthiness): a cached value is always a map,
    // and an empty map is a valid result that must count as a hit.
    if (key in state.cache) {
      return Promise.resolve(state.cache[key]);
    }

    if (inFlight[key]) {
      return inFlight[key];
    }

    commit('setLoading', { key, value: true });

    const request = AppService.getDynamicSubfields(adAccountId)
      .then(map => {
        const result = map || {};
        commit('setSubfields', { key, subfields: result });
        return result;
      })
      .finally(() => {
        delete inFlight[key];
        commit('setLoading', { key, value: false });
      });

    inFlight[key] = request;

    return request;
  },
};

const mutations = {
  setSubfields(state, { key, subfields }) {
    state.cache[key] = subfields;
  },
  setLoading(state, { key, value }) {
    state.loading[key] = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
